// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ikheH{padding:15px 0}.C1fAU{padding:0}.MQ_Nd{overflow:initial}.v6jY6{display:flex;flex-direction:row;gap:16px;padding:0 0}.v6jY6 .jmMed{border-radius:8px}.v6jY6 .jmMed .ovYwB{display:flex;flex-direction:column;align-items:flex-start;text-align:start;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceTemplateSelector": `ikheH`,
	"confirmationModal": `C1fAU`,
	"confirmationModalContent": `MQ_Nd`,
	"cardButtonsContainer": `v6jY6`,
	"cardButton": `jmMed`,
	"cardButtonContent": `ovYwB`
};
export default ___CSS_LOADER_EXPORT___;
